import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { AuthGuard } from './auth/auth.guard';

// const routes: Routes = [
//   {
//     path: '',
//     component: MenuComponent,
//     canActivate: [AuthGuard],
//     children: [
//       { path: '', loadChildren: () => import('./cpos-modules/cpos.module').then(m => m.CPOSModule) },
//     ]
//   },
//   { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
//   { path: '**', component: NotfoundComponent }
// ];

const routes: Routes = [
  {
    path: '',
    component: MenuComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', loadChildren: './cpos-modules/cpos.module#CPOSModule' },
    ]
  },
  { path: 'auth', loadChildren: './auth/auth.module#AuthModule' },
  { path: '**', component: NotfoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})

export class AppRoutingModule { }
